import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const AiOpsDashboard = React.lazy(() => import("./AiOpsDashboard"));

/**
 * AI Ops — master-operator cockpit over the Mac Studio AI plane (usage by
 * key/model, agent sessions with captured I/O, hardware load history,
 * virtual-API-key minting = the billing lever). Sibling of the
 * Module Upgrade cockpit; never fanned out to tenants.
 *
 * Permission gating: `permissionLevel` resolves at runtime against the
 * backend manifest (business-builder-backend/src/modules/ai-ops/
 * permissions.ts) — edit THAT file to change who sees this.
 */
const aiOpsModuleConfig: ModuleConfig = {
    id: "ai-ops",
    name: "AI Ops",
    description: "Mac Studio AI usage, sessions, hardware telemetry and virtual API keys.",
    version: "0.2.0",
    enabled: true,
    category: "administration",
    order: 97,
    icon: "📊",

    routes: [
        {
            path: "/ai-ops",
            component: AiOpsDashboard,
            permissionLevel: "view",
            useLayout: true,
            // Full page width (Data Tables Standard rule 7.0): every tab is tables and charts.
            // noContainer already removes the 1280px Container; the page's own Box is 100% wide too.
            layoutOptions: { noContainer: true, maxW: "100%" },
        },
    ],

    navigation: [
        {
            label: "AI Ops",
            path: "/ai-ops",
            icon: "📊",
            permissionLevel: "view",
        },
    ],

    // Empty arrays = backend manifest is the SSOT.
    permissions: { view: [], create: [], edit: [], delete: [] },
};

export default aiOpsModuleConfig;
